import React from 'react';
import { Calendar, CalendarProps } from '@/tw-components/ui/calendar';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { format } from 'date-fns';
import { DateFormatter } from 'react-day-picker';
import clsx from 'clsx';
type Props = {
  calendarProps?: CalendarProps;
  formatter?: DateFormatter;
  classNames?: CalendarProps['classNames'];
  id?: string;
};
const formatCaption: DateFormatter = (month, options) => <div className="flex flex-col" data-sentry-component="formatCaption" data-sentry-source-file="WalkerCalendar.tsx">
    <span aria-label="month" className="text-darkGray text-base font-[600] leading-6 tracking-normal">
      {format(month, 'LLLL', {
      locale: options?.locale
    })}
    </span>
    <span className="text-[#818181] !text-[10px] text-center" aria-label="year">
      {month.getFullYear()}
    </span>
  </div>;
export const WalkerCalendar = ({
  calendarProps,
  formatter = formatCaption,
  classNames,
  id = 'walker-availability-calendar'
}: Props) => <Calendar id={id} data-cy="date-picker" classNames={{
  months: 'w-full',
  tbody: '[&>tr]:justify-between',
  head: '[&>tr]:justify-between',
  head_cell: '!text-[#727272] rounded-full w-9 font-[600] text-[0.8rem] mt-3 text-[10px] uppercase hero-new-font',
  nav_button: 'opacity-100',
  day_disabled: '!text-[#B2B2B2] !font-[300]',
  row: 'flex w-full mt-[6px]',
  caption: 'flex justify-center pt-1 relative items-center h-[40px]',
  ...classNames
}} formatters={{
  formatCaption: formatter,
  formatWeekdayName: day => format(day, 'ccc')
}} weekStartsOn={1} fromMonth={new Date()} components={{
  IconLeft: () => <span className="bg-[#FFF] w-[36px] h-[36px] p-1 flex justify-center items-center rounded-full absolute left-0 top-[-18px] cursor-pointer">
          <span className="rounded-full flex w-[26px] h-[26px] p-[2px] justify-center items-center mx-auto" style={{
      border: `1px solid #E5E5E5`
    }}>
            <ChevronLeftIcon className="h-3 w-3 text-black" />
          </span>
        </span>,
  IconRight: () => <span data-cy="date-picker-next-month" className={clsx('bg-[#FFF] w-[36px] h-[36px] p-1 flex justify-center items-center right-[2px]', 'rounded-full absolute top-[-18px] cursor-pointer')}>
          <span className="rounded-full flex w-[26px] h-[26px] p-[2px] justify-center items-center mx-auto" style={{
      border: `1px solid #E5E5E5`
    }}>
            <ChevronRightIcon className="h-3 w-3 text-black" />
          </span>
        </span>
}} {...calendarProps} data-sentry-element="Calendar" data-sentry-component="WalkerCalendar" data-sentry-source-file="WalkerCalendar.tsx" />;